import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const SurveyRespondentDetailMetadata = ({ respondent, survey, currentAccount }) => {
  if (!respondent || !survey) return null;
  const resListURL = `/accounts/${currentAccount}/respondents`;

  const resDetailURL = `/accounts/${currentAccount}/respondents/${respondent.id}`;
  const surveyDetailURL = `/accounts/${currentAccount}/surveys/${survey.id}`;
  return (
    <ul className="breadcrumbs">
      <li>
        <Link to={resListURL}>
          <FormattedMessage id="candidate.plural" defaultMessage="Candidates" />
        </Link>
      </li>
      <li>
        <Link to={resDetailURL}>{`${respondent.firstName} ${respondent.lastName}`}</Link>
      </li>
      <li>
        <FormattedMessage id="survey" defaultMessage="Survey" />
        :
        <Link to={surveyDetailURL}>{survey.name}</Link>
      </li>
    </ul>
  );
};

SurveyRespondentDetailMetadata.propTypes = {
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  survey: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default SurveyRespondentDetailMetadata;
